// extracted by mini-css-extract-plugin
module.exports = {"color":"_2C89R","dropdown":"_2ieZ7","fixLayout":"_23Mis"};